import React from "react";

const Footer = () => {
  return (
    <footer>
      <ul className="footer_links">
        <li>Terms of use</li>
        <li>About Kittizz</li>
      </ul>
      <p className="copyright">Copyright ©dahisland 2023</p>
    </footer>
  );
};

export default Footer;
